// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MantineCombobox_dropdown__S1h4B","option":"MantineCombobox_option__Do9bo"};